
import IVendorConfig from "src/environments/Ivendor-config";

export function synnexMapper(config: IVendorConfig, use: string){

  config.brandsOptionsToDisplay = [
    "Lenovo",
    "Acer",
    "ASUS",
    "Dell",
    "HP",
    "Samsung"
  ];

  config.subscriptionLicenses = [
    {
      name: "Annual",
      value: 6634316
    },
    {
      name: "Annual-Monthly",
      value: 5556220
    },
    {
      name: "None",
      value: 0
    }
  ]
  config.showAddToCartButton = false;
  config.showSaveResultsButton = true;

  if(use === 'default') {
    config.showIncludeEnterpriseLicenseBox = true;
    config.showAddToCartButton = true;
  }
}


